import script from "./center-bottom.vue?vue&type=script&setup=true&lang=js"
export * from "./center-bottom.vue?vue&type=script&setup=true&lang=js"

import "./center-bottom.vue?vue&type=style&index=0&id=eb436412&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb436412"]])

export default __exports__